import React from 'react'

import * as MobileCSS from './css/mobile.module.css'

export const MobileLayout = ({children}) => (
  <div className={MobileCSS.root}>
    {children}
  </div>
)
